import React, { useRef, useEffect, useState } from "react";
import Globe from "react-globe.gl";
import VideoOverlay from "./components/videooverlay.js";
import DirectoryOverlay from "./components/directoryoverlay.js";

export default function App() {
  const globeEl = useRef();
  const [hoveredPoint, setHoveredPoint] = useState(null);
  const [showDirectory, setShowDirectory] = useState(false);
  const [points] = useState([
    {
      lat: 34.0549,
      lng: -118.2426,
      continent: "NORTH AMERICA",
      location: "LOS ANGELES, UNITED STATES",
      name: "WHAT'S REALLY IN YOUR UNDERWEAR?",
      sell: "Skims’ scandalous new underwear underscores the fashion industry’s failure to prioritize sustainable and traditional production methods, as well as the lack of awareness about how our clothing impacts our bodies. Indian cotton, produced by brands like Anuprerna, offer a healthier, more responsible alternative.",
      author: "May Rosina Buckley",
      preview: "/visuals/PANTS.mp4",
      article: "/articles/may.html",
      model: "/models/skims.glb"
    },
    {
      lat: 45.4685,
      lng: 9.1824,
      location: "MILAN, ITALY",
      continent: "EUROPE",
      name: "IS 'MADE IT ITALY' PAST ITS SELL BY DATE?",
      sell: "Loro Piana is the most recent in a series of Italian brands accused of labour exploitation within their supply chain, leading many to question whether the ‘Made in Italy’ label still stands as a symbol of prestige. ",
      author: "Rory Fainaru",
      preview: "/visuals/milan.mp4",
      article: "/articles/milan.html",
      model: "/models/milan.glb"
    },
    {
      lat: 32.0584,
      lng: 118.7965,
      location: "NANJING, CHINA",
      continent: "ASIA",
      name: "FROM FARM TO FIBER: NATIVA™ BLOCKCHAIN TECHNOLOGY AND THE FUTURE OF TRACEABLE LUXURY",
      sell: "As consumer demands and EU regulations increase pressure on fashion labels for proof of sustainability claims, NATIVA™ offers a business model serving both land and people along its supply chain.",
      author: "Lynn Yin Dittel",
      preview: "/visuals/nativa.mp4",
      article: "/articles/nanjing.html"
    },
    {
      lat: 51.5072,
      lng: -0.1276,
      location: "LONDON, UNITED KINGDOM",
      continent: "EUROPE",
      name: "NO FOUR WALLS",
      sell: "An exploration into the fruitful commercial landscape of Black British marketplaces.",
      author: "Jasmine Amelia Dove",
      preview: "/visuals/jasmine.mp4",
      article: "/articles/london.html"
    },
    {
      lat: 6.6137,
      lng: 3.3553,
      location: "LAGOS, NIGERIA",
      continent: "AFRICA",
      name: "LUXURY LEATHERS: THE SECRET TO ITALIAN QUALITY GOODS IN NIGERIAN LEATHER",
      sell: "Nigerian leather is exported across Europe and used by luxury fashion houses with no credit given to its origins. Many local Nigerian designers, such as Mutayo Ekiye, are speaking out against this injustice and proving that Nigerian design and textiles should be respected.",
      author: "Millie Metzger",
      preview: "/visuals/millie.mp4",
      article: "/articles/lagos.html"
    },
    {
      lat: 23.8041,
      lng: 90.4152,
      location: "DHAKA, BANGLADESH",
      continent: "ASIA",
      name: "THE WINNER'S RACE",
      sell: "How colonial theories of language still define the value of brown and black labour in the modern supply chain.",
      author: "Dharam Rhana",
      preview: "/visuals/twr.mp4",
      article: "/articles/dharam.html"
    }
    
  ]);

  const [countries, setCountries] = useState({ features: [] });

   const [arcsData, setArcsData] = useState([]);

  // const [modelScene, setModelScene] = useState(null);

  // const modelLocation = { lat: 51.5072, lng: -0.1276 }; // London


  useEffect(() => {
    // Auto-rotation
    const controls = globeEl.current.controls();
    controls.autoRotate = true;
    controls.autoRotateSpeed = 0.15;

    // fetch('/datasets/countries.geojson').then(res => res.json())
    //   .then(countries => console.log(countries));
    //     // .then(({ features }) => setPlaces(features));

    // Load countries
    fetch("https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/world.geojson")
      .then((res) => res.json())
      .then((data) => {
        setCountries(data);
        console.log(data);
      });


      const hubs = [
  { name: "Nanjing", lat: 32.0603, lng: 118.7969 },
  { name: "Milan", lat: 45.4685, lng: 9.1824 },
  { name: "LA", lat: 34.0549, lng: -118.2426 },
  { name: "Lagos", lat: 6.6137, lng: 3.3553},
  { name: "Dhaka", lat: 23.8041, lng: 90.4152},
  { name: "London", lat: 51.5072, lng: -0.1276}
];

    const arcsData = [
      //Lynn
      {
        startLat: -32.5228, // Uruguay
        startLng: -55.7658,
        endLat: hubs[0].lat,
        endLng: hubs[0].lng,
        color: ["#00ccff", "#ffffff"]
      },
      {
        startLat: -40.9006, // New Zealand
        startLng: 174.8860,
        endLat: hubs[0].lat,
        endLng: hubs[0].lng,
        color: ["#00ccff", "#ffffff"]
      },
      {
        startLat: 51.5074, // London
        startLng: -0.1278,
        endLat: hubs[0].lat,
        endLng: hubs[0].lng,
        color: ["#00ccff", "#ffffff"]
      },
      {
        startLat: 48.8575, // Paris
        startLng: 2.3514,
        endLat: hubs[0].lat,
        endLng: hubs[0].lng,
        color: ["#00ccff", "#ffffff"]
      },
      //Rory
      {
        startLat: -9.1900, // Peru Andes
        startLng: -75.0152,
        endLat: hubs[1].lat,
        endLng: hubs[1].lng,
        color: ["#ff8000ff", "#ffffff"]
      },
      {
        startLat: 39.9042, // Beijing
        startLng: 116.4074,
        endLat: hubs[1].lat,
        endLng: hubs[1].lng,
        color: ["#ff8000ff", "#ffffff"]
      },
      {
        startLat: 40.7128, // NYC
        startLng: 74.0060,
        endLat: hubs[1].lat,
        endLng: hubs[1].lng,
        color: ["#ff8000ff", "#ffffff"]
      },
      //May
      {
        startLat: 22.9868, // West Bengal
        startLng: 87.8550,
        endLat: hubs[2].lat,
        endLng: hubs[2].lng,
        color: ["#ff82beff", "#ffffff"]
      },
      //Millie
      {
        startLat: 45.4685, // Italy
        startLng: 9.1824,
        endLat: hubs[3].lat,
        endLng: hubs[3].lng,
        color: ["#77ff00ff", "#ffffff"]
      },
      {
        startLat: 52.1951, // Cambridge
        startLng: -0.1313,
        endLat: hubs[3].lat,
        endLng: hubs[3].lng,
        color: ["#77ff00ff", "#ffffff"]
      },
     //Dharam
      {
        startLat: 51.55194, // Dollis Hill, London
        startLng: -0.23861,
        endLat: hubs[4].lat,
        endLng: hubs[4].lng,
        color: ["#ff0000ff", "#ffffff"]
      },
      {
        startLat: 53.9591, // Yorkshire England
        startLng: -1.0792,
        endLat: hubs[4].lat,
        endLng: hubs[4].lng,
        color: ["#ff0000ff", "#ffffff"]
      },
      //Jasmine
      {
        startLat: 14.4974, // Senegal
        startLng: -14.4524,
        endLat: hubs[5].lat,
        endLng: hubs[5].lng,
        color: ["#1500ffff", "#ffffff"]
      },
      {
        startLat: 7.9465, // Ghana
        startLng: -1.0232,
        endLat: hubs[5].lat,
        endLng: hubs[5].lng,
        color: ["#1500ffff", "#ffffff"]
      },
      {
        startLat: 9.0820, // Nigeria
        startLng: 8.6753,
        endLat: hubs[5].lat,
        endLng: hubs[5].lng,
        color: ["#1500ffff", "#ffffff"]
      }
    ];

    setArcsData(arcsData);

    // const loader = new GLTFLoader();
    // loader.load(
    //   "/models/market stall vector.glb",
    //   (gltf) => {
    //     const scene = gltf.scene;
    //     // scene.scale.set(0.2, 0.2, 0.2); // adjust scale as needed
    //     scene.rotation.y = Math.PI; // optional orientation adjustment
    //     setModelScene(scene);
    //     console.log('loaded model!');
    //     console.log(gltf.scene);
    //   },
    //   undefined,
    //   (err, data) => console.error("Error loading GLB model:", err, data)
    // );

  }, []);

  return (
    <div style={{ background: "black", height: "100vh" }}>
      <VideoOverlay />

<img
      src="../visuals/saturn.gif"  // replace with your actual GIF path
      alt="Open Directory"
      onClick={() => setShowDirectory(true)}
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        width: "auto",
        height: "30px",
        cursor: "pointer",
        zIndex: 9999,
      }}
    />

        {/* 🪐 Directory toggle button
    <button
      onClick={() => setShowDirectory(!showDirectory)}
      style={{
        position: "fixed",
        top: "20px",
        left: "20px",
        zIndex: 9999,
        background: "rgba(0,0,0,0.7)",
        color: "white",
        border: "1px solid rgba(255,255,255,0.3)",
        padding: "8px 12px",
        borderRadius: "4px",
        cursor: "pointer",
        backdropFilter: "blur(6px)"
      }}
    >
    </button> */}

    {showDirectory && (
      <DirectoryOverlay
        points={points}
        onClose={() => setShowDirectory(false)}
      />
    )}


      <Globe
        ref={globeEl}
        width={window.innerWidth}
        height={window.innerHeight}
        globeImageUrl="https://unpkg.com/three-globe/example/img/earth-blue-marble.jpg"
        bumpImageUrl="https://unpkg.com/three-globe/example/img/earth-topology.png"
        backgroundImageUrl="https://unpkg.com/three-globe/example/img/night-sky.png"
        showAtmosphere={true}
        atmosphereColor="lightskyblue"
        atmosphereAltitude={0.25}

        // objectsData={modelScene ? [modelLocation] : []}
        // objectLat={(d) => d.lat}
        // objectLng={(d) => d.lng}
        // objectAltitude={0.03}
        // objectThreeObject={() => modelScene.clone()}

        polygonsData={countries.features}
        polygonAltitude={0.01}
        polygonCapColor={() => "rgba(255, 255, 255, 0.05)"}
        polygonSideColor={() => "rgba(255,255,255,0.15)"}
        polygonStrokeColor={() => "#ffffff"}
        polygonLabel={({ properties: d }) => `${d.name}`}

        pointsData={points}
        pointLat={(d) => d.lat}
        pointLng={(d) => d.lng}
        pointRadius={0.8}
        pointColor={() => "rgba(255, 0, 0, 0.7)"}
        pointAltitude={0.015}

        // onHover={setHoveredPoint}
        // onClick={(point) => window.open(process.env.PUBLIC_URL + point.article, "_self")}
        // ✅ Hover + click handlers
        onPointHover={(point) => setHoveredPoint(point || null)}
        onPointClick={(point) => document.location.href = point.article}

        // 🟢 Replace orange columns with 3D models
        // customLayerData={points}
        // customThreeObject={(point) => {
        //   const obj = new THREE.Object3D();

        //   // // 🟣 Flat circle marker
        //   // const circleGeometry = new THREE.CircleGeometry(0.05, 32);
        //   // const circleMaterial = new THREE.MeshBasicMaterial({
        //   //   color: "red",
        //   //   transparent: true,
        //   //   opacity: 0.7,
        //   //   side: THREE.DoubleSide
        //   // });
        //   // const circle = new THREE.Mesh(circleGeometry, circleMaterial);

        //   // // Rotate the circle so it lies flat against the globe
        //   // circle.rotation.x = -Math.PI / 2;
        //   // obj.add(circle);

        //   // 🟢 Optional: Load model above circle
        //   if (point.model) {
        //     const loader = new GLTFLoader();
        //     loader.load(
        //       point.model,
        //       (gltf) => {
        //         const model = gltf.scene;
        //         model.scale.set(0.1, 0.1, 0.1);
        //         model.position.set(0, 0.05, 0);
        //         obj.add(model);
        //       },
        //       undefined,
        //       (err) => console.error("Error loading model:", err)
        //     );
        //   }

        //   return obj;
        // }}

        // customThreeObjectUpdate={(obj, point) => {
        //   if (!globeEl.current) return;

        //   const { lat, lng } = point;
        //   const phi = (90 - lat) * (Math.PI / 180);
        //   const theta = (180 - lng) * (Math.PI / 180);
        //   const radius = globeEl.current.getGlobeRadius();

        //   obj.position.x = radius * Math.sin(phi) * Math.cos(theta);
        //   obj.position.y = radius * Math.cos(phi);
        //   obj.position.z = radius * Math.sin(phi) * Math.sin(theta);

        // }}

      // ✨ new glowing blue arcs
        arcsData={arcsData}
        arcColor={d => d.color}
        arcAltitude={d => {
          // Compute distance between points
          const latDiff = d.endLat - d.startLat;
          const lngDiff = d.endLng - d.startLng;
          const distance = Math.sqrt(latDiff*latDiff + lngDiff*lngDiff);

          // Scale altitude with distance
          return 0.2 + 0.5 * (distance / 180); // 0.2–0.7 range
        }}
        arcStroke={0.7}
        arcDashLength={0.9}
        arcDashGap={0.005}
        arcDashAnimateTime={5000}
        

        // ✨ add glowing dots at arc endpoints
        arcLabel={() => ""}
        arcsTransitionDuration={0}
      />


      {hoveredPoint && (
        <div
          style={{
            position: "fixed",
            left: `${window.innerWidth / 2 - 150}px`,
            bottom: "100px",
            width: "300px",
            background: "rgba(0, 0, 0, 0.8)",
            color: "white",
            padding: "15px",
            borderRadius: "4px",
            pointerEvents: "none",
            transition: "opacity 0.3s ease",
            zIndex: 9999,
            backdropFilter: "blur(6px)",
          }}
        >
          <p style={{ fontFamily: "monospace", fontSize: "0.6rem", opacity: 0.6, letterSpacing: 1.5 }}>{hoveredPoint.location}</p>
          <h3 style={{ fontSize: "1.1rem", marginBottom: "4px" }}>{hoveredPoint.name}</h3>
          <p style={{ fontFamily: "georgia", fontSize: "0.9rem", opacity: 0.85 }}>{hoveredPoint.sell}</p>
          <p style={{ fontSize: "0.8rem", marginTop: "8px", opacity: 0.6 }}>
            by {hoveredPoint.author}
          </p>
          {/* ✅ media preview section */}
          {/\.(mp4|mov|webm)$/i.test(hoveredPoint.preview) ? (
            <video
              src={hoveredPoint.preview}
              autoPlay
              loop
              muted
              playsInline
              style={{
                width: "100%",
                marginTop: "10px",
                objectFit: "cover",
              }}
            />
          ) : (
            <img
              src={hoveredPoint.preview}
              alt={hoveredPoint.name}
              style={{
                width: "100%",
                marginTop: "10px",
                objectFit: "cover",
              }}
            />
          )}
        </div>
      )}

    </div>
  );
}